import { useQuery } from "@tanstack/react-query";
import { queryUserByID } from "supabase/users";

type UseQueryUserParams = {
  uid: string;
};

export const useQueryUser = (params: UseQueryUserParams) => {
  const { uid } = params;

  const {
    isLoading,
    isError,
    error,
    data: user,
  } = useQuery({
    queryKey: ["user", uid],
    queryFn: () => {
      return queryUserByID({ uid });
    },
  });

  return { isLoading, isError, error, user };
};
